import { normalizeBetDocFilePath } from './product-board.utils';

/** Parse **Handoff:** line or frontmatter `handoff` from bet markdown. */
export function parseHandoffPathFromBetMarkdown(
  markdown: string | null | undefined,
  frontmatterHandoff?: string | null
): string | undefined {
  const fromFm = frontmatterHandoff?.trim();
  if (fromFm) return normalizeBetDocFilePath(fromFm);

  if (!markdown?.trim()) return undefined;
  const body = markdown.replace(/^---[\s\S]*?---\s*/m, '');

  const plain = body.match(
    /\*\*Handoff:\*\*\s+(`?)(docs\/[^\s`\n]+\.md|flownotes-app-docs\/[^\s`\n]+\.md)\1/i
  );
  if (plain?.[2]) return normalizeBetDocFilePath(plain[2]);

  const linked = body.match(/\*\*Handoff:\*\*\s+\[[^\]]+\]\(([^)]+\.md)\)/i);
  if (linked?.[1]) return normalizeBetDocFilePath(linked[1]);

  return undefined;
}

export function resolveCloudDispatchTargets(
  item: {
    path?: string;
    handoffPath?: string;
    documentId?: string;
    handoffDocumentId?: string;
  },
  betPreviewMarkdown?: string | null
): {
  betPath: string | undefined;
  handoffPath: string | undefined;
  dispatchPath: string | undefined;
  dispatchDocumentId: string | undefined;
} {
  const betPath = normalizeBetDocFilePath(item.path);
  const handoffPath =
    normalizeBetDocFilePath(item.handoffPath) ||
    parseHandoffPathFromBetMarkdown(betPreviewMarkdown ?? null);

  const dispatchPath = handoffPath || betPath;
  const dispatchDocumentId = (handoffPath ? item.handoffDocumentId : undefined) || item.documentId;

  return { betPath, handoffPath, dispatchPath, dispatchDocumentId };
}
